import React from 'react';

import { useController, useForm } from 'react-hook-form';
import {
  LbFormControlLabel,
  LbInput,
  Radio,
  RadioGroup,
  Surface,
  TitleWithDescription,
} from '@infoods/lifebase-ui';

import classes from './VerificationMethodCard.module.scss';
import {
  VERIFICATION_CHANNEL,
  VerificationChannel,
} from '../../../../constants/verificationChannel';
import { validateEmail } from '../../../../../shared/utils/reactHookFormUtils';

type FormValues = {
  verificationChannel: VerificationChannel;
  email?: string | null;
};

type VerificationMethodCardProps = {
  formId: string;
  defaultValues: FormValues;
  onChangeVerificationMethod: (
    verificationChannel: VerificationChannel,
    email?: string | null,
  ) => void;
};

const VerificationMethodCard = ({
  formId,
  defaultValues,
  onChangeVerificationMethod,
}: VerificationMethodCardProps) => {
  const { control, handleSubmit, watch } = useForm<FormValues>({
    shouldUnregister: true,
    defaultValues,
  });

  const { field } = useController({ control, name: 'verificationChannel' });

  const selectedVerificationChannel = watch('verificationChannel');

  const onSubmit = handleSubmit(async (data) => {
    onChangeVerificationMethod(data.verificationChannel, data.email);
  });

  return (
    <form id={formId} onSubmit={onSubmit}>
      <Surface className={classes.contentContainer}>
        <TitleWithDescription
          title="Use Another Method"
          description="Select an alternative verification option to regain access to your account."
        />
        <RadioGroup {...field} className={classes.radioGroup}>
          <LbFormControlLabel
            control={<Radio value={VERIFICATION_CHANNEL.EMAIL} />}
            label="Verification code via email"
          />
          {selectedVerificationChannel === VERIFICATION_CHANNEL.EMAIL && (
            <LbInput
              control={control}
              name="email"
              variant="outlined"
              size="small"
              type="email"
              label="Enter email"
              rules={{
                required: 'Email is required',
                validate: { validateEmail },
              }}
            />
          )}
          <LbFormControlLabel
            control={<Radio value={VERIFICATION_CHANNEL.SMS} />}
            label="Verification code via text message"
          />
        </RadioGroup>
      </Surface>
    </form>
  );
};

export { VerificationMethodCard };
